import firebase from 'firebase/app'
import 'firebase/storage';
import 'firebase/firestore';

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyAgZHSulcAYFI6lyzU3PvczouZVs0G3534",
  authDomain: "nazmusgram.firebaseapp.com",
  projectId: "nazmusgram",
  storageBucket: "nazmusgram.appspot.com",
  messagingSenderId: "908566584891",
  appId: "1:908566584891:web:8a5dcf90dd5f3ada9a461e"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

const projectStorage = firebase.storage();
const projectFirestore = firebase.firestore();
const timestamp = firebase.firestore.FieldValue.serverTimestamp;

export { projectStorage, projectFirestore, timestamp };